module.exports = __webpack_public_path__ + "img/rsz_img_0532.d94d0709.jpg";